export default __webpack_public_path__ + "static/media/pillows.d138f612.svg";